


















































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import CostInputDetailsSummaryPanel from '@/components/construction/constructionedit/CostInputDetailsSummaryPanel.vue';
import CreateDetailsPanel from '@/components/common/modules/CreateDetailsPanel.vue';
import DetailsSummaryArea from '@/components/common/modules/DetailsSummaryArea.vue';
import { FieldChildrenProp } from '@/services/hexabase/types';

@Component({
  components: {
    CostInputDetailsSummaryPanel,
    SingleText,
    CreateDetailsPanel,
    DetailsSummaryArea
  }
})
export default class FixedCostInput extends Vue {
  // 親コンポーネントから送られてくる表示データ
  @Prop({ default: () => [] })
  private fixedCostInputDetailFieldsDatas!: Array<Array<Array<FieldChildrenProp>>>;
  // 親コンポーネントから送られてくるカラム情報
  @Prop({ default: '' })
  private fixedCostInputDetailFieldCols?: Array<string>;
  @Prop()
  parentRegistDatas: any;
  // 受注確定額
  @Prop({ default: '0' })
  private orderPrice?: string;
  /** 親コンポーネントが持っている各マスタのデータ */
  @Prop()
  private masterData?: any;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };

  private summaryTotal() {
    let sum = 0;
    for (const i in this.fixedCostInputDetailFieldsDatas) {
      sum += this.sumTotal(this.fixedCostInputDetailFieldsDatas[i], Number(i));
    }
    return sum;
  }

  private sumTotal(data: Array<Array<FieldChildrenProp>>, index: number) {
    let sum = 0;
    for (const i in data) {
      // 特定の自動集計を行う、display_idの検索
      const quantityUnitPrice = data[i].find(function(v) {
        if (v.display_id === 'quantity;unit_price;unit') {
          return v['props']?.value;
        }
      });

      // 特定の自動集計を行う、display_idがある場合
      if (quantityUnitPrice) {
        const baseValue = quantityUnitPrice['props']?.value;
        const leftValue = isNaN(Number(baseValue.split(';')[0]))
          ? 0
          : Number(baseValue.split(';')[0]);
        const rightValue = isNaN(Number(baseValue.split(';')[1]))
          ? 0
          : Number(baseValue.split(';')[1]);
        sum += leftValue * rightValue;
      } else {
        const quantity = data[i].find(function(v) {
          if (v.display_id === 'quantity') {
            return v['props']?.value;
          }
        });
        const unit_price = data[i].find(function(v) {
          if (v.display_id === 'unit_price') {
            return v['props']?.value;
          }
        });
        if (quantity && unit_price) {
          sum += Number(quantity['props']?.value) * Number(unit_price['props']?.value);
        }
      }
    }
    return sum;
  }

  /**
   * 明細情報欄(材料費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputMaterialCostAddDetailArea')
  private fixedCostInputMaterialCostAddDetailArea() {
    return { detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputMaterialCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostDeleteRow')
  private fixedCostInputMaterialCostDeleteRow(index: number) {
    if (this.parentRegistDatas[0]) {
      this.registData = { ...this.parentRegistDatas[0] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputMaterialCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostCreateDetailsData')
  private fixedCostInputMaterialCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 0 };
  }

  /**
   * 明細情報欄(材料費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputMaterialCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputMaterialCostCatchInputDetail')
  private fixedCostInputMaterialCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 0;
    return response;
  }

  /**
   * 明細情報欄(労務費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputMaterialCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputLaborCostAddDetailArea')
  private fixedCostInputLaborCostAddDetailArea() {
    return { detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputLaborCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostDeleteRow')
  private fixedCostInputLaborCostDeleteRow(index: number) {
    if (this.parentRegistDatas[1]) {
      this.registData = { ...this.parentRegistDatas[1] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputLaborCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostCreateDetailsData')
  private fixedCostInputLaborCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 1 };
  }

  /**
   * 明細情報欄(労務費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputLaborCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputLaborCostCatchInputDetail')
  private fixedCostInputLaborCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 1;
    return response;
  }

  /**
   * 明細情報欄(消耗品・その他経費)の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module fixedCostInputConsumableCostAddDetailArea
   * @return {void}
   */
  @Emit('fixedCostInputConsumableCostAddDetailArea')
  private fixedCostInputConsumableCostAddDetailArea(index: number) {
    return { detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module fixedCostInputConsumableCostDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostDeleteRow')
  private fixedCostInputConsumableCostDeleteRow(index: number) {
    if (this.parentRegistDatas[2]) {
      this.registData = { ...this.parentRegistDatas[2] };
    }
    return { response: this.registData, index: index, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module fixedCostInputConsumableCostCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostCreateDetailsData')
  private fixedCostInputConsumableCostCreateDetailsData(response: any) {
    return { response: response, detailTypeIndex: 2 };
  }

  /**
   * 明細情報欄(消耗品・その他経費)パネルの子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module fixedCostInputConsumableCostCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('fixedCostInputConsumableCostCatchInputDetail')
  private fixedCostInputConsumableCostCatchInputDetail(response: any) {
    response.detailTypeIndex = 2;
    return response;
  }
}
